"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useFetchJson(url) {
    const [data, setData] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [retryCount, setRetryCount] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        if (!url) {
            return;
        }
        setLoading(true);
        setError(null);
        fetch(url, { cache: 'no-cache' })
            .then((data) => data.json())
            .then(setData)
            .catch((err) => {
            setError(err);
            setData(null);
        })
            .finally(() => {
            setLoading(false);
        });
    }, [
        url,
        // !!!IMPORTANT!!! retryCount must be passed as a dep so it triggers a new fetch even if we're not actually referencing it in the effect
        retryCount,
    ]);
    const retry = (0, react_1.useCallback)(() => {
        if (!loading) {
            setRetryCount((x) => x + 1);
        }
    }, [loading]);
    return [data, loading, error, retry, retryCount];
}
exports.default = useFetchJson;
